<!--
 * COPYRIGHT Transtron Inc 2022
 *
 * 機能名：Copyright
 *
 * 作成者：2022/2/11 ノア）黄
 * 最終修正者：2022/2/11 ノア）黄
 *
 -->
<template>
  <audio preload ref="audio">
    <source src="audio/20000.wav" type="audio/mpeg" />
  </audio>
</template>

<script lang="ts">
import { Component, Vue, Ref } from 'vue-property-decorator'
import { audioService } from './audioService'

@Component({
  name: 'TtiAudio'
})
export default class TtiAudio extends Vue {
  @Ref('audio') audio: HTMLAudioElement | undefined

  /**
   * インスタンスがマウントされたちょうど後にフック処理
   *
   * @returns {void}
   */
  mounted(): void {
    this.$log.debug('TtiAudio > mounted')
    audioService.init(this)
  }
}
</script>
